export enum ESeverity {
  CRITICAL = 'CRITICAL',
  MAJOR = 'MAJOR',
  MINOR = 'MINOR',
  LOW = 'LOW',
  NA = 'NA',
}

export const SEVERITY_HEX: Readonly<Record<ESeverity, string>> = {
  [ESeverity.CRITICAL]: '#ef4444',
  [ESeverity.MAJOR]: '#f97316',
  [ESeverity.MINOR]: '#eab308',
  [ESeverity.LOW]: '#3b82f6',
  [ESeverity.NA]: '#6b7280',
};
